<template>
<div>
  <user :visible.sync="userVisible"></user>

  <!-- Top bar always shown -->
  <div class="dokhlab-top" v-if="scrollTop===0">
    <div class="dokhlab-top-home" @click="redirect(`${$store.state.host}/dokhlab/#/home`)">Dokholyan Lab</div>
    <div class="dokhlab-top-research" @click="redirect(`${$store.state.host}/dokhlab/#/research`)">Research</div>
    <div class="dokhlab-top-publications" @click="redirect(`${$store.state.host}/dokhlab/#/publications`)">Publications</div>
    <div class="dokhlab-top-services" @click="redirect(`${$store.state.host}/dokhlab/#/tools`)">Services</div>
    <div class="dokhlab-top-login hidden-xs-only" v-if="$store.state.user!=''" style="cursor:pointer" @click="userVisible=true"> {{$store.state.user.username}} </div>
    <div class="dokhlab-top-login hidden-xs-only" v-else style="cursor:pointer" @click="userVisible=true">Login</div>
  </div>

  <div class="content">
    <!--
    <keep-alive exclude="[Task, Home]">
    -->
      <router-view/>
    <!--
    </keep-alive>
    -->
  </div>
</div>
</template>

<script>
import User from '../User'

export default {
  name: 'app',

  data () {
    return {
      userVisible: false,
      scrollTop: 0
    }
  },

  components: {
    User
  },

  methods: {
    setScrollTop () {
      this.$store.commit('setScrollTop')
    },

    redirect (url) {
      this.$store.dispatch('redirect', url)
    },

    logout () {
      let v = this
      v.$store.dispatch('logout')
    }
  },

  created: function () {
    window.addEventListener('scroll', this.setScrollTop)
  },

  destroyed: function () {
    window.removeEventListener('scroll', this.setScrollTop)
  },

  mounted () {
    console.log(this.$store)
    this.$store.dispatch('autoLogin')
    this.$store.commit('setkv', {k:'server',v:'ohm'})
  }
}
</script>

<style lang="scss">
@import "./styles/theme.scss";
body {
  overflow-y: auto;
  font-size: 12px;
  /*
  min-width: 1000px;
  */
  height: 100%;
  background-color: white;
  width: 100%;
  margin: 0px;
  padding: 0px;
  /*
  background-color: #f7f7f7;
  */
  /*
  background: url('./assets/app-bg.jpg') no-repeat 50%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  */
  font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Oxygen-Sans,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue","Source Sans Pro",sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

li.menu-item {
  padding: 0 20px;
  font-size: 14px;
  height: 56px;
  line-height: 56px;
  cursor: pointer;
}

input {
  /*
  background: #c0dbd1;
  */
  background: $theme-color-extreme-light;
  border: 1px solid #A7A7A7;
  color: #111111;
}

table {
  height: 100%;
  width: 100%;
  border-collapse:collapse;
  overflow: hidden;
}

tr {
  width: 100%;
  height: 100%;
  margin: 0px;
}

a {
  color: rgb(144, 147, 153);
  text-decoration: None;
}

a:hover {
  color: rgb(144,147,153);
}

a:visited {
  color: rgb(144, 147, 153);
}

</style>

<style lang="scss" scoped>
@import "./styles/theme.scss";

#app {
  margin: 0px;
  padding: 0px;
  width: 100%;
  height: 100%;
  position: relative;
}

.unlogin {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  text-align: center;
}

.unlogin-background {
  position: absolute;
  width: 100%;
  height: 100%;
}

.unlogin-background img {
  height: 100%;
  width: auto;
}

.ohm-title {
  font-size: 50px;
  font-weight: 800;
  color: white;
}

.ohm-subtitle {
  font-size: 12px;
  color: white;
}

.login-box {
  display: inline-block;
  width: 300px;
  margin: auto auto;
  z-index: 50;

  /*
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 120px 0px 0px 60px;
  color: white;
  overflow: auto;
  */
  font-size: 30px;
}

.login-username {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  height: 50px;
  width: 100%;
  border-top: none;
  border-bottom: 1px solid #eeeeee;
  border-left: none;
  border-right: none;
  margin: 0px;
  padding: 0px 5px;
  display: block;
  box-sizing: border-box;
}

.login-password {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  height: 50px;
  width: 100%;
  border: none;
  margin: 0px;
  padding: 0px 5px;
  display: block;
  box-sizing: border-box;
}

.login-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
}

.button-signin {
  text-align: center;
  color: white;
  background-color: #125c0c;
  border-radius: 5px;
  cursor: pointer;
  width: 100%;
  box-sizing: border-box;
  padding: 5px;
  font-size: 20px;
  margin-top: 10px;
}

.button-signin:hover {
  opacity: 0.5;
}

.button-signup {
  border-radius: 5px;
  cursor: pointer;
  padding: 10px;
}

.button-signup:hover {
  color: $theme-color-light;
}

.unlogin-reference {
  position: absolute;
  left: 100px;
  bottom: 20px;
  font-size: 18px;
  color: white;
}

.dokhlab-top {
  height: 30px;
  background-color: #333333;
  color: white;
  display: flex;
  align-items: center;
  flex-direction: row;
  font-weight: bold;
}

.dokhlab-top-home {
  padding: 0px 20px;
  cursor: pointer;
  height: 100%;
  line-height: 30px;
}

.dokhlab-top-home:hover {
  background-color: #7c7c7c;
}

.dokhlab-top-research {
  padding: 0px 20px;
  cursor: pointer;
  height: 100%;
  line-height: 30px;
}

.dokhlab-top-research:hover {
  background-color: #7c7c7c;
}

.dokhlab-top-publications {
  padding: 0px 20px;
  cursor: pointer;
  height: 100%;
  line-height: 30px;
}

.dokhlab-top-publications:hover {
  background-color: #7c7c7c;
}

.dokhlab-top-services {
  padding: 0px 20px;
  cursor: pointer;
  height: 100%;
  line-height: 30px;
}

.dokhlab-top-services:hover {
  background-color: #7c7c7c;
}

.dokhlab-top-login {
  margin-left: auto;
  margin-right: 10px;
  /*
  border-bottom: 1px solid #111111;
  background: #f1f1f1;
  padding: 2px 2px 4px 2px;
  */
}

.simcomp-top {
  width: 100%;
  position: relative;
}

.simcomp-top-cover {
 position: absolute;
 top: 0;
 left: 0;
 right: 0;
 bottom: 0;
 background: transparentify(-color, white, 0.2);
}

.simcomp-top-content {
  margin: 0px auto;
  width: $content-width;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  font-size: 24px;
  color: #9ea2ac;
  z-index: 19;
}

.simcomp-top-head {
  font-size: 40px;
  height: 150px;
  line-height: 150px;
  font-family: "Times New Roman", Times, serif;
}

.simcomp-top-head img {
  height: 100%;
}

.simcomp-top-menu {
  font-size: 18px;
  margin-left: auto;
  margin-right: 0px;
  display: flex;
  align-items: center;
  flex-direction: row;
  padding: 0px 0px 0px 250px;
  /*
  background-image: linear-gradient(to left, $theme-color, white);
  background-origin: border-box;
  */
  color: white;
  z-index: 20;
}

.simcomp-top-submit {
  cursor: pointer;
  /*
  border-right: 1px solid $theme-color;
  */
  padding: 5px 15px;
  height: 100%;
}

.simcomp-top-submit:hover {
  /*
  color: white;
  color: $theme-color;
  */
  background-color: $theme-color-light;
}

.simcomp-top-queue {
  cursor: pointer;
  /*
  border-right: 1px solid $theme-color;
  */
  padding: 5px 15px;
}

.simcomp-top-queue:hover {
  /*
  color: white;
  color: $theme-color;
  */
  background-color: $theme-color-light;
}

.simcomp-top-help {
  cursor: pointer;
  padding: 5px 15px;
}

.simcomp-top-help:hover {
  /*
  color: white;
  color: $theme-color;
  */
  background-color: $theme-color-light;
}

.nav-menuitem {
  margin: 10px 0px;
}

.nav {
  height: 100%;
  width: 250px;
  min-width: 250px;
  background: #2e3238;
  color: white;
  padding: 0px;
  vertical-align: text-top;
}

.nav-header {
  margin: 20px;
  line-height: 40px;
  vertical-align: middle;
}

.content {
  /*
  width: $theme-width;
  margin: 0px auto;
  */
  width: 100%;
}

/*
.zoom {
  position: absolute;
  right: 5px;
  top: 5px;
  font-size: 18px;
  color: #878d99;
  cursor: pointer;
  z-index: 99;
}
 */

.left-nav {
  margin-bottom: 0px;
}

.box-card {
  padding: 0px 0px;
}

.submenu-list li.menu-item {
  padding: 0 40px;
}

li.menu-item:hover {
  /*background-color: #ecf5ff*/
}

li.menu-item.is-active {
  /*
  color: #ffd04b;
   */
font-weight: bold;
color: #67c23a;
}

li.menu-item * {
  vertical-align: middle;
}

li.menu-item i {
  margin-right: 5px;
  width: 24px;
  text-align: center;
  font-size: 18px;
  color: #878d99;
}

li.menu-item.is-active i {
  color: inherit;
}

.submenu-title {
  position: relative;
}

li.menu-item i.submenu-arrow {
  position: absolute;
  right: 20px;
  top: 50%;
  margin-top: -7px;
  font-size: 12px;
}

#bg {
  margin: 0px 0px 10px 0px;
}

div.el-card__header {
  padding: 0px 20px;
  /*
  background-color: #223e4a;
  color: white;
   */
}

.grey-button {
  color: #5a5e66;
}

.unselectable {
  -moz-user-select: -moz-none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.el-button--text {
  color: #67c23a;
}

.logout-button {
  color: red;
  cursor:pointer;
}

.login-button {
  color: red;
  cursor:pointer;
}

.register-button {
  color: cyan;
  cursor:pointer;
}

.signup-label {
  font-size: 12px;
  text-align: left;
}

</style>

